// @ts-nocheck
import { ModalUI } from 'sonata-react-components';
import styled from 'styled-components';

export const AIInsightsModalStyled = styled(ModalUI)`
  .aiInsightsModal {
    &__configuration {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    &__description {
      margin-bottom: 16px;
      display: flex;
      gap: 8px;
      flex-direction: column;
      width: 100%;
      font-size: ${props => props.theme.fontSizeS};
      color: ${props => props.theme.uiColors.textBodyDefault};
    }

    &__loadingVeil {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 8001;
    }

    &__submit {
      display: flex;
      width: 100%;
      justify-content: center;
      margin-top: 48px;
    }

    &__details {
      margin-top: 32px;
      white-space: pre-line;
    }

    &__metricSelector,
    &__dimensionSelector,
    &__languageSelector {

      &Box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;

        &Title {
          all: initial;
          color: ${props => props.theme.uiColors.aiInsightsModalTextColor};
          font-family: ${props => props.theme.fontRegular};
          font-size: ${props => props.theme.fontSizeXS};
          letter-spacing: 0;
          line-height: 16px;
        }
      }

      &TagSelector {
        display: flex;
        gap: 23px;
        height: fit-content;
        align-items: center;
        margin-top: 16px;

        .multipleTagSelector {
          column-gap: 23px;
        }
      }
    }

    &__languageSelectorBoxTitle {
      flex: 2;
    }

    &__languageSelectorBox {
      align-items: center;
      display: flex;
      flex-direction: row;
    }

    &__selector {
      flex: 4;
      width: 100%;
    }

    &__detailsAiResponse {
      font-size: ${props => props.theme.fontSizeS};
      h4 {
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeS};
      }
      p {
        font-size: ${props => props.theme.fontSizeS};
      }
    }
  }
`;
